import { z } from "zod";

const producerTypeValues = ["Unknown", "RabbitAmqp091", "Webhook"] as const;

export const producerTypeSchema = z.enum(producerTypeValues);
export type ProducerType = z.infer<typeof producerTypeSchema>;

export const ProducerTypeValue: Record<ProducerType, ProducerType> = {
	Unknown: "Unknown",
	RabbitAmqp091: "RabbitAmqp091",
	Webhook: "Webhook",
};
